import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SubscribeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M6 13.7305H10C10 14.8351 9.10457 15.7305 8 15.7305C6.94564 15.7305 6.08183 14.9146 6.00549 13.8798L6 13.7305H10H6ZM8 1.73053C10.2091 1.73053 12 3.52139 12 5.73053V8.76081L13.6838 10.339C13.8856 10.528 14 10.7921 14 11.0686V11.7305C14 12.2828 13.5523 12.7305 13 12.7305H3C2.44772 12.7305 2 12.2828 2 11.7305V11.0686C2 10.7921 2.11445 10.528 2.31616 10.339L4 8.76081V5.73053C4 3.52139 5.79086 1.73053 8 1.73053Z"
		/>
	</svg>
))
